<template>
  <b-container fluid class="my-4">
    <b-row>
      <b-col cols="12" md="8" lg="6" class="mx-auto">
        <b-card title="Editar Cirugia">
          <validation-observer v-slot="{ invalid }" ref="observer">
            <b-form @submit.prevent="submitForm">
              <b-form-group label-for="codigo">
                <label>Código: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="codigo"
                  rules="required"
                >
                  <b-form-input
                    id="codigo"
                    :state="errors.length > 0 ? false : null"
                    v-model="cirugia.codigo"
                    type="text"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <label>Nombre: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nombre"
                  rules="required"
                >
                  <b-form-input
                    id="nombre"
                    :state="errors.length > 0 ? false : null"
                    v-model="cirugia.nombre"
                    type="text"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group label-for="preciodoc">
                <label>Precio Doctor: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="preciodoc"
                  rules="required"
                >
                  <b-form-input
                    id="preciodoc"
                    :state="errors.length > 0 ? false : null"
                    v-model="cirugia.preciodoc"
                    type="number"
                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group label-for="precioan">
                <label
                  >Precio Anestesiologo:
                  <span class="text-danger">*</span></label
                >
                <validation-provider
                  #default="{ errors }"
                  name="precioan"
                  rules="required"
                >
                  <b-form-input
                    id="precioan"
                    :state="errors.length > 0 ? false : null"
                    v-model="cirugia.precioan"
                    type="number"
                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group label-for="establecimiento">
                <label
                  >Establecimiento: <span class="text-danger">*</span></label
                >
                <validation-provider
                  #default="{ errors }"
                  name="establecimiento"
                  rules="required"
                >
                  <v-select
                    id="establecimiento"
                    v-model="cirugia.establecimiento"
                    placeholder="Buscar por establecimiento."
                    :options="establecimientos"
                    :reduce="(option) => option.value"
                    label="text"
                    class="d-inline-block w-100"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group label-for="especialidad">
                <label>Especialidad: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="especialidad"
                  rules="required"
                >
                  <v-select
                    id="especialidad"
                    v-model="cirugia.especialidad"
                    placeholder="Buscar por especialidad."
                    :options="especialidades"
                    :reduce="(option) => option.value"
                    label="text"
                    class="d-inline-block w-100"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group label="Estado:" label-for="estado-switch">
                <b-form-checkbox
                  id="estado-switch"
                  v-model="cirugia.estado"
                  value="1"
                  unchecked-value="0"
                  switch
                  disabled
                >
                </b-form-checkbox>
              </b-form-group>

              <b-button type="submit" variant="primary"
                >Actualizar procedimiento</b-button
              >
              <b-button @click="salir()" class="float-right" variant="danger"
                >Salir</b-button
              >
            </b-form>
          </validation-observer>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  data() {
    return {
      cirugia: {
        id: "",
        token: "",
        descripcion: "",
        codigo: "",
        preciodoc: 0,
        prpecioan: 0,
        especialidad: "",
        establecimiento: "",
        especialidades: [],
        establecimientos: [],

        estado: 1,
      },
    };
  },
  created() {
    const idCirugia = this.$route.params.id;
    const tokencirugia = this.$route.params.token;
    console.log(idCirugia);
    console.log("Llego");
    this.fetchEstablecimientos();
    this.fetchCirugia(tokencirugia);
    this.fetchEspecialidades();
    this.comprobarPermisos();
  },
  methods: {
    comprobarPermisos() {
      if (localStorage.getItem("permisos").indexOf("editar_cirugia") === -1) {
        this.$router.push({ name: "not-permitted" });
      }
    },
    salir() {
      this.$router.push({ name: "consultar_cartera_cirugia" });
    },
    async fetchEstablecimientos() {
      const query = `
                        query {
                            allEstablecimientos {
                                id
                                Descripcion
                                uniCodigo
                            }
                        }
                    `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        this.establecimientos = response.data.data.allEstablecimientos.map(
          (item) => ({
            value: item.id,
            text: item.Descripcion,
            uniCodigo: item.uniCodigo,
          })
        );
      } catch (error) {
        console.error("An error occurred while fetching the options:", error);
      }
    },
    async fetchEspecialidades() {
      const query = `
                        query {
                            allEspecialidades {
                                id
                                descripcion
                            }
                        }
                    `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        this.especialidades = response.data.data.allEspecialidades.map(
          (item) => ({
            value: item.id,
            text: item.descripcion,
          })
        );
      } catch (error) {
        console.error("An error occurred while fetching the options:", error);
      }
    },

    async submitForm() {
      console.log("Aqui");
      console.log(this.cirugia);
      const precioDoctorFormateado = parseInt(this.cirugia.preciodoc);
      const precioAnestesiologoFormateado = parseInt(this.cirugia.precioan);

      const query = `
        mutation actualizarCirugiaMedica( $cirugiaDatos: CirugiaMedicaUpdateInput!) {
  actualizarCirugiaMedica( cirugiaDatos: $cirugiaDatos) {
    
    cirugiaActualizado {
      token
      id
      codigo
      nombre
      establecimiento {
        id
        Descripcion
      }
      especialidad {
        id
        descripcion
      }
      precioDoctor
      precioAnestesiologo
      estado
    }
    status
    message
  }
}
        `;
      const variables = {
        cirugiaDatos: {
          token: this.cirugia.token,
          datos: {
            codigo: this.cirugia.codigo,
            nombre: this.cirugia.nombre,
            establecimiento: this.cirugia.establecimiento,
            especialidad: this.cirugia.especialidad,
            precioDoctor: precioDoctorFormateado, // Asegurarse de que el valor sea un número
            precioAnestesiologo: precioAnestesiologoFormateado,
            estado: this.cirugia.estado,
          },
        },
      };
      console.log(variables);

      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });

        if (response.data.data.actualizarCirugiaMedica.status === "success") {
          await this.$swal({
            icon: "success",
            title: "Éxito",
            text: "La Cirugia se actualizó correctamente.",
          });
          this.$router.push({ name: "consultar_cartera_cirugia" });
        } else {
          throw new Error(response.data.data.message);
        }
      } catch (error) {
        await this.$swal({
          icon: "error",
          title: "Error",
          text: error.message || "Hubo un problema al actualizar la cirugia.",
        });
      }
    },
    async fetchCirugia(tokencirugia) {
      const query = `query obtenerCirugia($tokencirugia: String!) {
                allCirugiasMedicas(tokencirugia: $tokencirugia) {
                    total
                    status
                    message
                    cirugiasMedicas {
                        id
                      	token
                        nombre
                        codigo
                        estado
                      usuarioCreador{
                        id
                        username
                      }
                      precioDoctor
                      precioAnestesiologo
                      especialidad{
                        id
                        descripcion
                      }
                        establecimiento {
                            id
                            Descripcion
                        }
                    }
    								
                    pageInfo {
                        currentPage      
                        totalPages
                        hasNextPage
                        hasPreviousPage
                    }
                }
            }
        `;

      const variables = {
        tokencirugia: tokencirugia,
      };

      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });

        if (response.data.data.allCirugiasMedicas.status === "Success") {
          if (response.data.data.allCirugiasMedicas.cirugiasMedicas) {
            console.log(
              "cirugia:",
              response.data.data.allCirugiasMedicas.cirugiasMedicas[0]
            );
            const proc =
              response.data.data.allCirugiasMedicas.cirugiasMedicas[0];
            this.cirugia = {
              token: proc.token,
              nombre: proc.nombre,
              codigo: proc.codigo,
              preciodoc: proc.precioDoctor,
              precioan: proc.precioAnestesiologo,
              especialidad: proc.especialidad.id,
              establecimiento: proc.establecimiento.id,
              estado: proc.estado,
            };
          }
        } else {
          console.error(
            "Error al obtener la procedimiento:",
            response.data.message
          );
        }
      } catch (error) {
        console.error("Error al realizar la consulta GraphQL:", error);
      }
    },
  },
};
</script>

<style>
/* Estilos personalizados si son necesarios */
</style>
